module.exports = __webpack_public_path__ + "img/home_index_text.265d3ba4.png";